import React from 'react';
import {getBlockComponent} from '../contentTypeConfig';

type StrapiBlockProps = {
	strapiBlockData: any;
	contentType: string;
	translationNamespace: string;
};

export const StrapiBlock: React.FC<StrapiBlockProps> = ({
	strapiBlockData,
	contentType,
	translationNamespace,
}) => {
	const Component = getBlockComponent(contentType, strapiBlockData.__component);
	if (!Component) {
		return null;
	}

	return (
		<Component
			strapiBlockData={strapiBlockData}
			translationNamespace={translationNamespace}
		/>
	);
};
